import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import en from "../locales/en.json";
import lv from "../locales/lv.json";
import ru from "../locales/ru.json";

export const languageResources = {
  en: { translation: en },
  lv: { translation: lv },
  ru: { translation: ru },
};

export const supportedLanguages = ["en", "lv", "ru"];

i18next.use(LanguageDetector).use(initReactI18next).init({
  compatibilityJSON: "v4",
  debug: true,
  fallbackLng: "en",
  resources: languageResources,
});

export default i18next;
